import {Component, input, output, signal} from '@angular/core';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {TranslatePipe} from '@ngx-translate/core';
import {Location} from '@on-the-go-web/sdk';

// Shared location list UI used by both the bottom-nav's bottom sheet and the
// sidebar's dialog picker, so the two entry points always show identical
// content — only how the host closes and navigates differs.
@Component({
  selector: 'otg-location-picker-list',
  imports: [MatListModule, MatIconModule, MatDividerModule, TranslatePipe],
  templateUrl: './location-picker-list.html',
  styleUrl: './location-picker-list.scss',
})
export class LocationPickerList {
  locations = input.required<Location[]>();
  currentLocationId = input<string | null>(null);

  locationSelected = output<string>();
  addLocationClicked = output<void>();

  // Logo URLs that failed to load, so we fall back to the storefront icon
  // instead of a broken image — tracked per-location since the list shows
  // every location at once.
  private _failedLogoIds = signal<ReadonlySet<string>>(new Set());

  hasLogo(location: Location): boolean {
    return !!location.logo?.url && !this._failedLogoIds().has(location.id!);
  }

  onLogoError(locationId: string | undefined): void {
    if (!locationId) return;
    this._failedLogoIds.update((ids) => new Set(ids).add(locationId));
  }
}
